import React from "react";
import "../sass/Content.scss";
import satellite from "../sass/assets/satellite.png";

const About = () => {
  return (
    <div className="contentWrapper">
      {/* <img className="heroImg" alt="satellite" src={satellite} /> */}
      <h1>About</h1>
      <p>
        EarthSights is an analytics dashboard for citizen scientists to
        understand our changing neighbourhood through dynamic satellite data.
      </p>

      <p>
        SkyServe's aim with EarthSIGHTS is to place data and facts on the table
        when there are conversations around
        <ul>
          <li>climate change</li>
          <li>disaster management</li>
          <li>food security</li>
          <li>urbanization</li>
        </ul>
        and a plethora of large-scale and enduring topics of debate. The open
        nature of the platform gives SkyServe's engineers a chance to experiment
        with new datasets, new visualization, and interactive features with the
        community at large and encourage participation from the public - all
        with the theme of giving the overview effect of Earth.
      </p>

      <p>
        Imagery and data points are made available on the platform from a
        variety of sources including open-source geospatial data, images from
        government agencies, and private organizations.
      </p>
    </div>
  );
};

export default About;
